import "./Story.module.css";
import Header from "@/reusable_sections/Header";
import TheHeartOfEnfield from "./sections/TheHeartOfEnfield";
import OurPhilosophy from "./sections/OurPhilosophy";
import KindWords from "./sections/KindWords";
import Footer from "@/reusable_sections/Footer";
export default function StoryPage() {
  return <div>
      <Header />
      <TheHeartOfEnfield />
      <OurPhilosophy />
      <KindWords />
      <Footer />
    </div>;
}